// Human-readable key combo for debug logs, e.g. "Ctrl+Shift+F".
export const describeKey = (event: KeyboardEvent) =>
  [
    event.ctrlKey && 'Ctrl',
    event.metaKey && 'Meta',
    event.altKey && 'Alt',
    event.shiftKey && 'Shift',
    event.key,
  ]
    .filter(Boolean)
    .join('+');
